'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Storage$() {
}
export { $c_Lpresto_Storage$ as $c_Lpresto_Storage$ };
$p = $c_Lpresto_Storage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Storage$;
/** @constructor */
function $h_Lpresto_Storage$() {
}
export { $h_Lpresto_Storage$ as $h_Lpresto_Storage$ };
$h_Lpresto_Storage$.prototype = $p;
$p.cHi = (function(key, converter) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().jP(window.localStorage.getItem(key.l()));
  if (this$1.k()) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
  } else {
    var arg1 = this$1.q();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(converter.v(arg1));
  }
});
$p.cOY = (function(key, value, converter) {
  window.localStorage.setItem(key.l(), converter.v(value));
});
var $d_Lpresto_Storage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Storage$, "presto.Storage$", ({
  RP: 1
}));
export { $d_Lpresto_Storage$ as $d_Lpresto_Storage$ };
var $n_Lpresto_Storage$;
function $m_Lpresto_Storage$() {
  if ((!$n_Lpresto_Storage$)) {
    $n_Lpresto_Storage$ = new $c_Lpresto_Storage$();
  }
  return $n_Lpresto_Storage$;
}
export { $m_Lpresto_Storage$ as $m_Lpresto_Storage$ };
//# sourceMappingURL=presto.-Storage$.js.map
